import { SHA512 } from 'crypto-es';

const base64Encode = (value: string): string => {
  if (typeof globalThis !== 'undefined' && typeof globalThis.btoa === 'function') {
    return globalThis.btoa(value);
  }

  throw new Error('Base64 encoding is not available in this environment.');
};

const base64Decode = (value: string): string => {
  if (typeof globalThis !== 'undefined' && typeof globalThis.atob === 'function') {
    return globalThis.atob(value);
  }

  throw new Error('Base64 decoding is not available in this environment.');
};

export const hashSha512 = (value: string): string => SHA512(value).toString();

export const CryptoUtil = {
  hash(value: string): string {
    return hashSha512(value);
  },
  base64Encode(value: string): string {
    return base64Encode(value);
  },
  base64Decode(value: string): string {
    return base64Decode(value);
  },
};


